export default __webpack_public_path__ + "static/media/about_us_vision.190ffce8.jpg";